export function SectionSkeleton() {
  return (
    <div className="w-full py-20 flex items-center justify-center">
      <div className="w-8 h-8 border-2 border-gold/30 border-t-gold rounded-full animate-spin" />
    </div>
  );
}
